import React from "react";
import { SplOfferData } from "../../../constants";

const ProductsOnSale = () => {
  return (
  <></>
  );
};

export default ProductsOnSale;
